package ir.yusefpasha.style

import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.hover
import ir.yusefpasha.util.Constants
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.filter
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@OptIn(ExperimentalComposeWebApi::class)
val AboutImageStyle by ComponentStyle {
    base {
        Modifier
            .styleModifier {
                filter {
                    grayscale(100.percent)
                }
            }
            .borderRadius(
                topLeft = 50.px,
                topRight = 25.px,
                bottomLeft = 25.px,
                bottomRight = 50.px,
            )
            .rotate(0.deg)
            .transition(CSSTransition(property = TransitionProperty.All, duration = Constants.ANIMATION_DURATION))
    }
    hover {
        Modifier
            .styleModifier {
                filter {
                    grayscale(0.percent)
                }
            }
            .borderRadius(
                topLeft = 70.px,
                topRight = 35.px,
                bottomLeft = 35.px,
                bottomRight = 70.px,
            )
            .rotate(5.deg)
            .transition(CSSTransition(property = TransitionProperty.All, duration = Constants.ANIMATION_DURATION))
    }
}

val AboutTextStyle by ComponentStyle {
    base {
        Modifier
            .opacity(50.percent)
            .transition(CSSTransition(property = TransitionProperty.All, duration = Constants.ANIMATION_DURATION))
    }
    hover {
        Modifier
            .opacity(100.percent)
            .transition(CSSTransition(property = TransitionProperty.All, duration = Constants.ANIMATION_DURATION))
    }
}